document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".scroll-line-wrapper .scroll-line-path").forEach(path => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        path.style.strokeDashoffset = "0";
                        observer.disconnect(); // Nur einmal animieren
                    }
                });
            },
            { threshold: 0.1 }
        );

        observer.observe(path);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gallery-carousel-container').forEach(container => {
        const carousel = container.querySelector('.gallery-carousel');
        const leftArrow = container.querySelector('.carousel-arrow.left');
        const rightArrow = container.querySelector('.carousel-arrow.right');
        const images = Array.from(container.querySelectorAll('.gallery-image'));
        const galleryId = container.getAttribute('data-gallery-id');
        const modalElement = document.getElementById(galleryId + '_modal');
        const modal = modalElement ? new bootstrap.Modal(modalElement) : null;
        const modalCarousel = document.getElementById(galleryId + '_carousel');
        const caption = modalElement ? modalElement.querySelector('.caption') : null;
        let bsCarousel = null;

        const ensureCarouselInstance = () => {
            if (!modalCarousel) return null;
            if (bsCarousel) return bsCarousel;
            const existing = bootstrap.Carousel.getInstance(modalCarousel);
            if (existing) {
                bsCarousel = existing;
            } else {
                bsCarousel = new bootstrap.Carousel(modalCarousel, { ride: false });
            }
            return bsCarousel;
        };

        const updateCaptionFromSlide = (indexOverride = null) => {
            if (!caption || !modalCarousel) return;
            const slides = Array.from(modalCarousel.querySelectorAll('.carousel-item'));
            const slide = indexOverride !== null ? slides[indexOverride] : slides.find(item => item.classList.contains('active'));
            if (!slide) return;
            const titleEl = slide.querySelector('.title');
            caption.textContent = titleEl ? titleEl.textContent.trim() : '';
        };

        function updateArrows() {
            if (!carousel || !leftArrow || !rightArrow) return;
            const canScroll = carousel.scrollWidth > carousel.clientWidth + 1;
            leftArrow.style.display = rightArrow.style.display = canScroll ? 'flex' : 'none';
            if (canScroll) {
                leftArrow.disabled = carousel.scrollLeft <= 0;
                rightArrow.disabled = carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 1;
            }
        }

        function onImagesLoaded(callback) {
            if (!carousel) {
                callback();
                return;
            }
            let loaded = 0;
            const imgs = carousel.querySelectorAll('img');
            if (imgs.length === 0) return callback();
            imgs.forEach(img => {
                if (img.complete) {
                    loaded++;
                    if (loaded === imgs.length) callback();
                } else {
                    img.addEventListener('load', () => {
                        loaded++;
                        if (loaded === imgs.length) callback();
                    });
                    img.addEventListener('error', () => {
                        loaded++;
                        if (loaded === imgs.length) callback();
                    });
                }
            });
        }

        onImagesLoaded(updateArrows);

        if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                if (!carousel) return;
                carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });
                setTimeout(updateArrows, 400);
            });
        }
        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                if (!carousel) return;
                carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' });
                setTimeout(updateArrows, 400);
            });
        }
        if (carousel) {
            carousel.addEventListener('scroll', updateArrows);
        }
        window.addEventListener('resize', updateArrows);
        updateArrows();

        if (modalCarousel) {
            modalCarousel.addEventListener('slid.bs.carousel', () => updateCaptionFromSlide());
        }

        images.forEach((img, idx) => {
            img.addEventListener('click', () => {
                if (!modal) return;
                const targetIdx = Number(img.getAttribute('data-index')) || idx;
                const instance = ensureCarouselInstance();
                if (instance && Number.isInteger(targetIdx)) {
                    instance.to(targetIdx);
                    updateCaptionFromSlide(targetIdx);
                }
                modal.show();
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mod_eventreader .event.soldout .btn.btn-primary').forEach(btn => {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
        const tagName = btn.tagName.toLowerCase();
        if (tagName === 'a') {
            btn.setAttribute('tabindex', '-1');
        } else if (tagName === 'button') {
            btn.disabled = true;
        }
    });
});


// --- Accessible navigation (desktop & mobile) ---
(() => {
    const DESKTOP_QUERY = window.matchMedia('(min-width: 1200px)');
    const menubarStore = new WeakMap();
    let idCounter = 0;

    const uid = (prefix) => {
        idCounter += 1;
        return `${prefix}-${idCounter}`;
    };

    const getDirectChild = (root, selector) => root.querySelector(`:scope > ${selector}`);
    const getDirectChildren = (root, selector) => Array.from(root.querySelectorAll(`:scope > ${selector}`));
    const ensureId = (element, prefix) => {
        if (!element.id) {
            element.id = uid(prefix);
        }
    };

    const setRovingTabindex = (elements, active) => {
        const isDesktop = DESKTOP_QUERY.matches;
        elements.forEach(el => {
            if (!el) return;
            el.setAttribute('tabindex', isDesktop ? (el === active ? '0' : '-1') : '0');
        });
    };

    const getSubmenu = (trigger) => {
        const li = trigger.closest('li');
        return li ? getDirectChild(li, 'ul') : null;
    };

    const getSubmenuItems = (submenu) => getDirectChildren(submenu, 'li')
        .map(li => getDirectChild(li, '[role="menuitem"]'))
        .filter(Boolean);

    const closeSubmenu = (trigger, { focusParent = false } = {}) => {
        const submenu = getSubmenu(trigger);
        if (!submenu || submenu.hidden) return;
        trigger.setAttribute('aria-expanded', 'false');
        const li = trigger.closest('li');
        if (li) li.dataset.open = 'false';
        submenu.hidden = true;
        getSubmenuItems(submenu).forEach(item => item.setAttribute('tabindex', '-1'));
        if (focusParent) {
            trigger.focus();
        }
    };

    const closeAllSubmenus = (root, exceptTrigger) => {
        root.querySelectorAll('[role="menuitem"][aria-expanded="true"]').forEach(trigger => {
            if (trigger !== exceptTrigger) {
                closeSubmenu(trigger);
            }
        });
    };

    const openSubmenu = (trigger, { focus = false, focusLast = false } = {}) => {
        const submenu = getSubmenu(trigger);
        if (!submenu) return;
        const nav = trigger.closest('nav');
        if (nav) {
            closeAllSubmenus(nav, trigger);
        }
        trigger.setAttribute('aria-expanded', 'true');
        const li = trigger.closest('li');
        if (li) li.dataset.open = 'true';
        submenu.hidden = false;
        const items = getSubmenuItems(submenu);
        if (!items.length) return;
        const target = focus ? (focusLast ? items[items.length - 1] : items[0]) : items[0];
        setRovingTabindex(items, target);
        if (focus) {
            target?.focus();
        }
    };

    const moveFocus = (elements, current, direction = 1) => {
        if (!elements.length) return;
        const idx = elements.indexOf(current);
        const nextIndex = (idx + direction + elements.length) % elements.length;
        const next = elements[nextIndex];
        setRovingTabindex(elements, next);
        next?.focus();
    };

    const handleTopKeydown = (event, menubar) => {
        const data = menubarStore.get(menubar);
        if (!data) return;
        const { topTriggers } = data;
        const trigger = event.currentTarget;
        const submenu = getSubmenu(trigger);
        const key = event.key;
        if (!topTriggers.includes(trigger)) return;

        switch (key) {
            case 'ArrowRight':
                event.preventDefault();
                moveFocus(topTriggers, trigger, 1);
                closeSubmenu(trigger);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                moveFocus(topTriggers, trigger, -1);
                closeSubmenu(trigger);
                break;
            case 'Home':
                event.preventDefault();
                setRovingTabindex(topTriggers, topTriggers[0]);
                topTriggers[0]?.focus();
                closeSubmenu(trigger);
                break;
            case 'End':
                event.preventDefault();
                setRovingTabindex(topTriggers, topTriggers[topTriggers.length - 1]);
                topTriggers[topTriggers.length - 1]?.focus();
                closeSubmenu(trigger);
                break;
            case 'ArrowDown':
                if (submenu) {
                    event.preventDefault();
                    openSubmenu(trigger, { focus: true });
                }
                break;
            case 'ArrowUp':
                if (submenu) {
                    event.preventDefault();
                    openSubmenu(trigger, { focus: true, focusLast: true });
                }
                break;
            case 'Enter':
            case ' ':
                if (submenu) {
                    event.preventDefault();
                    if (trigger.getAttribute('aria-expanded') === 'true') {
                        closeSubmenu(trigger);
                    } else {
                        openSubmenu(trigger, { focus: true });
                    }
                }
                break;
            case 'Escape':
                if (submenu && trigger.getAttribute('aria-expanded') === 'true') {
                    event.preventDefault();
                    closeSubmenu(trigger, { focusParent: true });
                }
                break;
            default:
                break;
        }
    };

    const handleSubmenuKeydown = (event, submenu, parentTrigger, menubar) => {
        const key = event.key;
        const items = getSubmenuItems(submenu);
        const current = event.currentTarget;
        const data = menubarStore.get(menubar);

        switch (key) {
            case 'ArrowDown':
                event.preventDefault();
                moveFocus(items, current, 1);
                break;
            case 'ArrowUp':
                event.preventDefault();
                moveFocus(items, current, -1);
                break;
            case 'Home':
                event.preventDefault();
                setRovingTabindex(items, items[0]);
                items[0]?.focus();
                break;
            case 'End':
                event.preventDefault();
                setRovingTabindex(items, items[items.length - 1]);
                items[items.length - 1]?.focus();
                break;
            case 'Escape':
                event.preventDefault();
                closeSubmenu(parentTrigger, { focusParent: true });
                break;
            case 'ArrowLeft':
                if (data) {
                    event.preventDefault();
                    closeSubmenu(parentTrigger);
                    moveFocus(data.topTriggers, parentTrigger, -1);
                }
                break;
            case 'ArrowRight':
                if (data) {
                    event.preventDefault();
                    closeSubmenu(parentTrigger);
                    moveFocus(data.topTriggers, parentTrigger, 1);
                }
                break;
            case 'Tab':
                closeAllSubmenus(menubar.closest('nav') ?? document);
                break;
            default:
                break;
        }
    };

    const handleTriggerClick = (event, trigger) => {
        const submenu = getSubmenu(trigger);
        if (!submenu) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (!expanded) {
            event.preventDefault();
            openSubmenu(trigger, { focus: DESKTOP_QUERY.matches });
        } else if (DESKTOP_QUERY.matches) {
            closeSubmenu(trigger);
        }
    };

    const initSubmenu = (trigger, submenu) => {
        ensureId(trigger, 'menuitem');
        ensureId(submenu, 'submenu');
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', submenu.id);
        submenu.hidden = true;
        submenu.setAttribute('role', 'menu');
        submenu.setAttribute('aria-labelledby', trigger.id);

        const submenuItems = getSubmenuItems(submenu);
        setRovingTabindex(submenuItems, submenuItems[0]);
        submenuItems.forEach(item => {
            if (item.tagName === 'STRONG') {
                item.setAttribute('aria-disabled', 'true');
            }
            item.addEventListener('keydown', (event) => {
                const menubar = trigger.closest('.navbar-nav.level_1');
                if (menubar) {
                    handleSubmenuKeydown(event, submenu, trigger, menubar);
                }
            });
        });
    };

    const initNavigation = (menubar) => {
        if (!menubar || menubarStore.has(menubar)) return;
        const nav = menubar.closest('nav');
        if (!nav) return;

        nav.setAttribute('role', nav.getAttribute('role') || 'navigation');
        nav.setAttribute('aria-label', nav.getAttribute('aria-label') || 'Hauptnavigation');

        menubar.setAttribute('role', 'menubar');
        menubar.setAttribute('aria-orientation', 'horizontal');

        const listItems = getDirectChildren(menubar, 'li');
        const topTriggers = [];

        listItems.forEach((li, index) => {
            li.setAttribute('role', 'none');
            const trigger = getDirectChild(li, '[role="menuitem"]') || getDirectChild(li, 'a, button, strong');
            if (!trigger) return;

            ensureId(trigger, 'menuitem');
            trigger.setAttribute('role', 'menuitem');
            if (trigger.tagName === 'STRONG') {
                trigger.setAttribute('aria-disabled', 'true');
            }
            trigger.setAttribute('tabindex', index === 0 ? '0' : '-1');
            topTriggers.push(trigger);

            const submenu = getDirectChild(li, 'ul');
            if (submenu) {
                initSubmenu(trigger, submenu);
                trigger.addEventListener('click', (event) => handleTriggerClick(event, trigger));
                li.addEventListener('pointerenter', () => {
                    if (DESKTOP_QUERY.matches) {
                        openSubmenu(trigger);
                    }
                });
                li.addEventListener('pointerleave', (event) => {
                    if (DESKTOP_QUERY.matches && !li.contains(event.relatedTarget)) {
                        closeSubmenu(trigger);
                    }
                });
            }

            trigger.addEventListener('keydown', (event) => handleTopKeydown(event, menubar));
            trigger.addEventListener('focus', () => setRovingTabindex(topTriggers, trigger));
        });

        menubarStore.set(menubar, { nav, topTriggers });
        setRovingTabindex(topTriggers, topTriggers[0]);

        document.addEventListener('click', (event) => {
            if (!nav.contains(event.target)) {
                closeAllSubmenus(nav);
            }
        });

        nav.addEventListener('focusout', () => {
            setTimeout(() => {
                if (!nav.contains(document.activeElement)) {
                    closeAllSubmenus(nav);
                }
            }, 0);
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('nav .navbar-nav.level_1').forEach(initNavigation);
    });

    document.addEventListener('hidden.bs.offcanvas', (event) => {
        const menubar = event.target.querySelector('.navbar-nav.level_1');
        if (menubar) {
            closeAllSubmenus(event.target);
            const data = menubarStore.get(menubar);
            if (data) {
                setRovingTabindex(data.topTriggers, data.topTriggers[0]);
            }
        }
    });
    DESKTOP_QUERY.addEventListener('change', () => {
        document.querySelectorAll('nav .navbar-nav.level_1').forEach(menubar => {
            const data = menubarStore.get(menubar);
            if (!data) return;
            const { topTriggers } = data;
            const activeTrigger = topTriggers.find(trigger => trigger.getAttribute('tabindex') === '0') || topTriggers[0];
            setRovingTabindex(topTriggers, activeTrigger);

            menubar.querySelectorAll('ul[role="menu"]').forEach(submenu => {
                const items = getSubmenuItems(submenu);
                if (items.length) {
                    setRovingTabindex(items, items[0]);
                }
            });
        });
    });
})();
